import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { readAllTenant, accessLocalStorage } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';
import './UploadsForm.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye, faPlus, faFilter, faTrash, faUpload, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';

export default function AudioUpload() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;
  
  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [nameFile, setNameFile] = useState(null);
  const [type, setType] = useState("");
  const [tenant, setTenant] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [tenantsDb, setTenantsDb] = useState([]);

  const getDataInitialPage = async () => {
      const dataUser = accessLocalStorage.getUserLocalStorage();
      const { user: { role, idtenant } } = dataUser;
      if (!dataUser) return history.push('/');
      if (dataUser && role !== 'root') return history.push('/home');
      let fetchTenants = await readAllTenant();
      if (!fetchTenants) return;
    let fetchDbTenants = await readAllTenant();
    if (!idtenant.includes('vgs')) fetchDbTenants = fetchDbTenants.filter((tenant) => tenant.short_name === idtenant);
    
    if(fetchDbTenants) setTenantsDb(fetchDbTenants)
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    getDataInitialPage();

    return () => {
      cancel = true
    };
  }, []);

  const handleFileChange = (e) => {
      setFile(e.target.files[0]);
      setNameFile(event.target.files[0].name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

  if (!file || !name.trim() || !type.trim() || tenant.trim().length !== 3) {
    setMessage("Todos os campos são obrigatórios e tenant deve ter 3 caracteres.");
    return;
  }

  const formData = new FormData();
  formData.append("audioFile", file);
  formData.append("name", name.trim());
  formData.append("type", type.trim());
  formData.append("tenant", tenant.trim());

  setLoading(true);
  
  try {
      const response = await fetch(`//${url}/api/uploads`, {
          method: "POST",
          body: formData,
      });

      const data = await response.json();
      if (response.ok) {
          toggleIsHidden('#upload-sended-info')
          setMessage(`Upload realizado com sucesso!`);
      } else {
          setMessage(`Erro: ${data.message}`);
      }
  } catch (error) {
      setMessage("Erro ao conectar com a API.");
  }

  setLoading(false);
};

return (
  <div className="uploads-container">
    <div className="uploads-header">
      <div className="uploads-title-wrapper">
        <svg className="uploads-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
        <div>
          <h1 className="uploads-title">Upload - Arquivos de Áudio</h1>
          <p className="uploads-subtitle">Envie arquivos de áudio para URA, MOH e Mensagens</p>
        </div>
      </div>
    </div>

    <div className="alerts-section">
      <div id="upload-sended-info" className="alert-message alert-info is-hidden">
        <div className="alert-header">
          <span>Informação!</span>
          <button className="alert-close" aria-label="info" onClick={() => toggleIsHidden('#upload-sended-info')}>×</button>
        </div>
        <div className="alert-body">
          {message}
        </div>
      </div>
    </div>

    <div className="upload-form-card">
      <form name="upload-form" id="upload-form" onSubmit={handleSubmit}>
        <div className="upload-form-row">
          <div className="upload-field upload-field-large">
            <label className="upload-label">Arquivo de áudio</label>
            <div className="upload-file-wrapper">
              <input 
                className="upload-file-input" 
                type="file" 
                name="resume" 
                accept="audio/*" 
                onChange={handleFileChange}
              />
              <div className="upload-file-button">
                <FontAwesomeIcon icon={faCloudUploadAlt} />
                <span>Selecionar arquivo</span>
              </div>
              <span className="upload-file-name">{nameFile ? nameFile : 'Nenhum arquivo selecionado...'}</span>
            </div>
          </div>

          <div className="upload-field upload-field-small">
            <label className="upload-label">Nome de Armazenamento</label>
            <input 
              className="upload-input" 
              name="name" 
              type="text" 
              onChange={(e) => setName(e.target.value)} 
              placeholder="Apenas texto" 
            />
          </div>

          <div className="upload-field upload-field-small">
            <label className="upload-label">Tipo de Áudio</label>
            <select className="upload-select" name="type" onChange={(e) => setType(e.target.value)}>
              <option value="">Selecione</option>
              <option value="ura">URA</option>
              <option value="moh">Música de Espera</option>
              <option value="msg">Mensagens</option>
            </select>
          </div>

          <div className="upload-field upload-field-small">
            <label className="upload-label">Cliente</label>
            <select className="upload-select" name="tenant" onChange={(e) => setTenant(e.target.value)}>
              <option value="">Selecione</option>
              {tenantsDb && tenantsDb.map((tenant) => (
                <option key={tenant.short_name} value={tenant.short_name}>
                  {tenant.name} - {tenant.short_name}
                </option>
              ))}
            </select>
          </div>

          <div className="upload-field upload-field-small">
            <button className="upload-submit-btn" type="submit" disabled={loading}>
              <FontAwesomeIcon icon={faUpload} />
              <span>{loading ? "Enviando..." : "Enviar"}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
);
}
